import { useState } from 'react';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { loginUser } from '../../Redux/Slice/Auth/authSlice';
import {useNavigate} from "react-router-dom";
import {getUser} from "../../Redux/Slice/User/userSlice";


const useLogin = () => {

    const navigate = useNavigate()
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const handleEmailChange = (e) => { setEmail(e.target.value) }
    const handlePasswordChange = (e) => { setPassword(e.target.value) }
    const dispatch = useDispatch()


    // const handleSubmit = async (e) => {
    //     e.preventDefault()
    //     setIsLoading(true)
    //     let response = await userLogin({ email, password })
    //     if (response.statusCode === 200) {
    //         toast?.success(response?.message)
    //         setIsLoading(false)
    //     } else if (response.statusCode === 401) {
    //         toast?.error(response?.errors)
    //         setIsLoading(false)
    //     } else {
    //         for (const [key, value] of Object.entries(response?.errors)) {
    //             toast?.error(value)
    //         }
    //         setIsLoading(false)
    //     }
    //     setIsLoading(false)
    // }


    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true)

        const body = {
            email,
            password
        }

        try {
            const response = await dispatch(loginUser(body)).unwrap();
            if (response.statusCode === 200) {
                await localStorage.setItem('access_token', response?.response?.data?.accessToken);
                toast?.success(response?.message)
                setIsLoading(false)
                dispatch(getUser())
                navigate('/');
            } else if (response.statusCode === 401) {
                toast?.error(response?.errors)
                setIsLoading(false)
            } else {
                for (const [key, value] of Object.entries(response?.errors)) {
                    toast?.error(value)
                }
                setIsLoading(false)
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log("errr in login", error)
        }
    }


    return [
        email,
        password,
        isLoading,
        handleEmailChange,
        handlePasswordChange,
        handleLogin
    ]
}

export default useLogin;